export default "__VITE_ASSET__1bjxVI6m__"